import { useState } from "react";
import { Button, Modal, message, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import useAxios from "../../hooks/useAxios";

const deleteEndpointMap = {
  trl: "/employee/deldoc/trl",
  cos: "/employee/deldoc/cos",
};

const ConfirmDelete = ({
  isService,
  rowId,
  docType,
  buttonText = "Delete Row",
  isIcon = false,
  onDeleted = () => {},
}) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { fetchData } = useAxios();

  const showModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const handleDelete = async () => {
    if (!isService) {
      const endpoint = `${deleteEndpointMap[docType]}/${rowId}`;

      if (!endpoint) {
        message.error("Invalid document type for deletion.");
        return;
      }

      setConfirmLoading(true);
      try {
        await fetchData({
          url: endpoint,
          method: "POST",
        });
        message.success("Successfully deleted.");
        onDeleted();
      } catch (error) {
        message.error("Something went wrong.");
      } finally {
        setConfirmLoading(false);
        closeModal();
      }
    } else {
      onDeleted();
      closeModal();
    }
  };

  return (
    <>
      <Tooltip title={buttonText}>
        <Button
          type="primary"
          danger
          icon={<DeleteOutlined />}
          onClick={showModal}
          shape={isIcon ? "circle" : undefined}
        >
          {isIcon ? null : buttonText}
        </Button>
      </Tooltip>

      <Modal
        title="Confirm Deletion"
        open={open}
        onOk={handleDelete}
        onCancel={closeModal}
        confirmLoading={confirmLoading}
        okText="Delete"
        okType="danger"
      >
        Are you sure you want to remove this item? This action cannot be undone.
      </Modal>
    </>
  );
};

export default ConfirmDelete;
